import { Box, BoxStyleProps } from '@frontend/ui-library';
import cx from 'classnames';

import { isExpiresInOneDay } from '../../utils';
import ExpirationText from '../ExpirationText';

import styles from './ExpirationBar.module.css';

export interface ExpirationBarProps extends BoxStyleProps {
  className?: string;
  expiresAt: number;
  chipVariant?: boolean;
}

export default function ExpirationBar({
  className,
  expiresAt,
  chipVariant,
  ...boxProps
}: ExpirationBarProps): JSX.Element {
  return (
    <Box
      className={cx(
        styles['base'],
        { [styles[`is-expiring`]]: isExpiresInOneDay(expiresAt) },
        { [styles[`base--variant-chip`]]: chipVariant },
        className
      )}
      {...boxProps}
    >
      <ExpirationText endDate={expiresAt} />
    </Box>
  );
}
